<template>
  <div
    class="flex flex-col items-center w-full gap-4 py-8"
    :style="{ minHeight: 'calc(100vh - 2.5rem - 3.5rem - 5rem)' }"
  >
    <div class="flex flex-col gap-4 px-10 py-10 w-152">
      <div class="flex items-center justify-between">
        <BlTextSubtitle1 text="Add tasks" />
        <BlInputButton
          v-if="!allTasksUsed"
          label="Add new task"
          @clicked="onAddTasks"
        />
        <BlTooltip v-else tooltip="You’ve reached the limit for tasks and can’t create a new one." >
          <BlInputButton label="Add new task" disabled />
        </BlTooltip>
      </div>
      <div
        class=""
        v-for="(code, index) in sortedTasks"
        :key="`task-code-item-${code.key}`"
      >
        <TasksCodesItem
          kind="client"
          :tasks="tasksCodes"
          :allTasksUsed="allTasksUsed"
          :defaultTasks="defaultTasks"
          :index="index"
          :code="code"
          @update="$emit('updateTask', $event)"
          @delete="$emit('removeTask', $event)"
          :readOnly="!currentUser.role.includes('admin')"
        />
      </div>
      <div class="flex items-center w-full">
        <div class="flex-grow h-1" :class="allTasksUsed ? 'bg-slate-400' : 'bg-light-purple'"></div>
        <div class="mx-4">
          <div class="" v-if="!allTasksUsed">
            <BlInputButton icon="plus" @clicked="onAddTasks" />
          </div>
          <div class="p-1 rounded bg-slate-400" v-else>
            <BlIcon icon="plus" color="grey" tooltip="You’ve reached the limit for tasks and can’t create a new one." class="w-6 h-6" />
          </div>
        </div>
        <div class="flex-grow h-1" :class="allTasksUsed ? 'bg-slate-400' : 'bg-light-purple'"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlInputButton from "../../../BlInputButton.vue";
import BlTextSubtitle1 from "../../../BlTextSubtitle1.vue";
import TasksCodesItem from "../../../repository/sbt/TasksCodesItem.vue";
import BlIcon from "../../../BlIcon.vue";
import BlTooltip from "../../../BlTooltip.vue";

export default {
  name: "NewTaskOverlay",
  components: { BlTextSubtitle1, BlInputButton, TasksCodesItem, BlIcon, BlTooltip },
  props: {
    tasksCodes: { type: Array, default: () => [] },
    defaultTasks: { type: Array, default: () => [] },
    sbtStep: { type: Number, default: 0 },
    typeInput: { type: String, default: "" }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapGetters(["currentUser"]),
    allTasksUsed() {
      return this.defaultTasks.length >= this.tasksCodes.length;
    },
    sortedTasks() {
      return [...this.defaultTasks].sort((a, b) => a.position - b.position);
    }
  },
  methods: {
    async onAddTasks() {
      this.$emit("addTask");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/overlay/NewTaskOverlay.vue